import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Service1() {
  const { t } = useTranslation();
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Animation du texte (arrive de la gauche)
      gsap.fromTo(
        textRef.current,
        {
          x: -100,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
          duration: 0.9,
          ease: "power2.out",
          scrollTrigger: {
            trigger: textRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );

      // Animation de l'image (arrive de la droite)
      gsap.fromTo(
        imageRef.current,
        {
          x: 100,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
          duration: 0.9,
          ease: "power2.out",
          scrollTrigger: {
            trigger: imageRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className="Accueil-Service Service1">
      <div className="TopSection">
        <p>[{t("services.label")}]</p>
        <h2>{t("service1.title")}</h2>
        <div className="Spacer"></div>
      </div>
      <article className="BottomSection">
        <div ref={textRef} className="BottomSection-Text">
          {t("service1.text")}
          <ul>
            <span>{t("service1.tag1")}</span>
            <span>{t("service1.tag2")}</span>
            <span>{t("service1.tag3")}</span>
            <span>{t("service1.tag4")}</span>
          </ul>
          <Link to="/services" rel="noreferrer" className="websiteBtn thin">
            {t("services.more")}
          </Link>
        </div>
        <img
          ref={imageRef}
          src={require("../../assets/img/Accueil/Service1.png")}
          alt=""
        />
      </article>
    </div>
  );
}
